import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ICellRendererParams } from "ag-grid-community";

import { EditAndDeleteButtons } from "../../../../shared/data-entries/EditAndDeleteButtons";
import { LadleRelining } from "../models/LadleMaintenance";

interface TableDataReturn {
  masterColumnDefs: ColDef<LadleRelining>[];
  defaultColDef: {
    sortable: boolean;
    resizable: boolean;
    flex: number;
    cellStyle: {
      display: string;
      alignItems: string;
      justifyContent: string;
    };
  };
}

interface useTableDataProps {
  handleEditRelining: (id: number) => void;
  handleDeleteRelining: (id: number) => void;
}

const centerCellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const useTableData = ({
  handleEditRelining,
  handleDeleteRelining,
}: useTableDataProps): TableDataReturn => {
  const masterColumnDefs: ColDef<LadleRelining>[] = [
    {
      headerName: "",
      cellRenderer: "agGroupCellRenderer",
      width: 40,
      maxWidth: 40,
      minWidth: 40,
      resizable: false,
      sortable: false,
      valueGetter: () => "",
    },
    {
      field: "StartCampaign",
      headerName: "Campaign Start",
      flex: 1,
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.StartCampaign, "MM/dd/yyyy HH:mm"),
      cellStyle: centerCellStyle,
    },
    {
      field: "EndCampaign",
      headerName: "Campaign End",
      flex: 1,
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.EndCampaign, "MM/dd/yyyy HH:mm"),
      cellStyle: centerCellStyle,
    },
    {
      field: "Heats",
      headerName: "#Heats",
      flex: 1,
      valueGetter: (params) => params.data?.Heats || "0",
      cellStyle: centerCellStyle,
    },
    {
      field: "ContactTime",
      headerName: "Contact Time",
      flex: 1,
      valueGetter: (params) =>
        params.data?.ContactTime ? `${params.data.ContactTime} min` : "-",
      cellStyle: centerCellStyle,
    },
    {
      field: "LadleCondition",
      headerName: "Ladle Condition",
      flex: 1,
      cellStyle: centerCellStyle,
    },
    {
      headerName: " ",
      flex: 1,
      cellRenderer: EditAndDeleteButtons,
      cellRendererParams: (params: ICellRendererParams) => ({
        deleteItem: handleDeleteRelining,
        onEdit: handleEditRelining,
        id: (params.data as LadleRelining).LadleReliningId,
      }),
    },
  ];

  const defaultColDef = {
    sortable: true,
    resizable: true,
    flex: 1,
    cellStyle: centerCellStyle,
  };

  return { masterColumnDefs, defaultColDef };
};
